import { SET_STUDENT_DATA } from "../types";

export default (state, action) => {
  const { type, payload, name, value } = action;
  switch (type) {
    case "ON_CHANGE": 
    return {
      ...state,
      formData: {...state.formData, [name]: value}
    }
    case "IFRAME":
      return {
        ...state,
        iframe: true,
      }
    case SET_STUDENT_DATA:
      return {
        ...state,
        studentData: payload,
      };
    default:
      return state;
  }
};
